import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class equipmentInventoryItemListAPI extends DIApi {
  controllerName = 'InventoryItems';

  GetStock(param) {
    const request = {
      url: this.getAPIUrl() + '/GetStock',
      data: {},
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy ra danh sách CCDC đã ghi tăng và số lượng ghi tăng >0 tính đến thời điểm hiện tại
   * ntban - 5.7.2023
   * @param {*} param
   * @returns
   */
  getInventoryForDecrement(posted_date) {
    const request = {
      url: this.getAPIUrl() + '/getInventoryForDecrement',
      data: posted_date,
    };

    return httpClient.postAsync(request);
  }
}

export default new equipmentInventoryItemListAPI();
